// extracted by mini-css-extract-plugin
module.exports = {"loading":"index_loading__03PfR","rotate":"index_rotate__LoRn8","svgContainer":"index_svgContainer__ItMyI"};